import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import {
  LEAD_GEN_PLACEMENTS,
  LEAD_GEN_DOWNLOAD_PLACEMENT_STATS,
} from '@src/constants/LeadGenerationConstants/index';
import usePlacementStatsDownload from './usePlacementStatsDownload';

const Downloads = ({ content }) => {
  const onSubmitPageOne = usePlacementStatsDownload();

  return (
    <section>
      <div className={styles.wrap}>
        <div className={styles.dl}>
          <h3>{content.heading}</h3>
          <p>{content.subheading}</p>
          <div className="flex flex-wrap justify-center gap-3">
            <LeadGenerationButton
              type="Download"
              text="Download Placement Stats"
              isOnePageForm
              formHeading="Placement Stats"
              pageOneButtonText="Download Now"
              buttonLocation={LEAD_GEN_DOWNLOAD_PLACEMENT_STATS}
              onSubmitPageOne={onSubmitPageOne}
              wrapperClassName="shrink-0"
            />
            <LeadGenerationButton
              text="Apply Now"
              buttonLocation={LEAD_GEN_PLACEMENTS}
              wrapperClassName="shrink-0"
              className="w-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Downloads;
